module.exports = __webpack_public_path__ + "static/media/boleto-logo.2bb14337.svg";